var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "140px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "核销编号:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.serialNo))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "订单编号:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.orderNo))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "项目类型:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.activityTypeName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "单价:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.unitPrice))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "报名内容:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.itemName))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "项目名称:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.activityTitle))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "所属教练:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.coachName))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "姓名:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.studentName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "联系方式:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.tel))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "微信昵称:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.nickName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "报名时间:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.enrollmentTime))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "核销时间:" } }, [
                    _c("div", [_vm._v(_vm._s(_vm.childData.opDate))])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }